export const AFFECTS = { ALL: "all", SELECTED: "selected" }
export const PRICE_DIRECTION = { INCREASE: "increase", DECREASE: "decrease" }
export const PRICE_TYPE = { PERCENT: "percent", FLAT: "flat" }

export const PRICE_TYPE_OPTIONS = [
  { label: "%", value: PRICE_TYPE.PERCENT },
  { label: "$", value: PRICE_TYPE.FLAT },
]

export const PLACEHOLDER_TICKET_TYPES = [
  { id: "adults", label: "Adults" },
  { id: "children", label: "Children" },
  { id: "vip", label: "VIP" },
]
